// Юнікод-емодзі для реакцій на повідомлення чату (як у Telegram). Набір
// вбудований: зовнішніх каталогів немає. Будь-який інший емодзі можна
// вписати в поле «свій» — сервер приймає будь-який піктографічний символ.

const split = (s) => [...s.split(/\s+/).filter(Boolean)]

export const EMOJI_GROUPS = [
  {
    id: 'faces',
    icon: '😀',
    emojis: split(
      '😀 😃 😄 😁 😆 😅 🤣 😂 🙂 🙃 😉 😊 😇 🥰 😍 🤩 😘 😗 😚 😙 😋 😛 😜 🤪 😝 🤑 🤗 🤭 🤫 🤔 🤐 🤨 😐 😑 😶 😏 😒 🙄 😬 🤥 😌 😔 😪 🤤 😴 😷 🤒 🤕 🤢 🤮 🤧 🥵 🥶 🥴 😵 🤯 🤠 🥳 😎 🤓 🧐 😕 😟 🙁 ☹️ 😮 😯 😲 😳 🥺 😦 😧 😨 😰 😥 😢 😭 😱 😖 😣 😞 😓 😩 😫 🥱 😤 😡 😠 🤬 😈 👿 💀 ☠️ 💩 🤡 👹 👺 👻 👽 👾 🤖',
    ),
  },
  {
    id: 'gestures',
    icon: '👍',
    emojis: split(
      '👍 👎 👌 🤌 🤏 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐️ 🖖 👋 🤝 🙏 ✍️ 💅 💪 🦾 👏 🙌 👐 🤲 🫶 🫡 🫠 🫢 🫣 🫤 🥹 🙈 🙉 🙊 👀 👁️ 👅 👄 🧠 🫀',
    ),
  },
  {
    id: 'hearts',
    icon: '❤️',
    emojis: split(
      '❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝 💟 ♥️ 💋 💯 💢 💥 💫 💦 💨 🕳️ 💬 💭 💤 🔥 ✨ ⭐ 🌟 ⚡ 🎉 🎊 🎈 🏆 🥇 🎯',
    ),
  },
  {
    id: 'anime',
    icon: '🍙',
    emojis: split(
      '🍙 🍜 🍣 🍱 🍡 🍥 🥢 🍵 🍶 🌸 🎌 ⛩️ 🗾 🎎 🎏 🎐 🧧 🐱 🐶 🦊 🐰 🐻 🐼 🐸 🐵 🐧 🐥 🦄 🐉 🐲 🐺 🦁 🐯 🐷 🦉 🦋 🐢 🐙 🦑 🌙 ☀️ 🌈 ⛄ ❄️ 🌊 🍀 🌹 🎮 🕹️ 🎵 🎶 🎧 🎤 🎬 📺',
    ),
  },
  {
    id: 'misc',
    icon: '🎲',
    emojis: split(
      '✅ ❌ ❓ ❗ ‼️ ⚠️ 🚫 ➕ ➖ ➡️ ⬅️ ⬆️ ⬇️ 🔴 🟠 🟡 🟢 🔵 🟣 ⚫ ⚪ 🆗 🆒 🆕 🔞 🚀 🛸 💎 💰 🪙 🎁 🕐 ⏳ 📌 📎 🔔 🔒 🔑 🧩 🎲 ♟️ 🃏 🏁 🚩 🏳️‍🌈 🇷🇺 🇺🇦 🇺🇸 🇯🇵',
    ),
  },
]

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🔥']

// Один емодзі (з модифікаторами) — а не назва смайла й не випадковий текст
export const isEmojiReaction = (value) => {
  const v = String(value || '').trim()
  if (!v || v.length > 24) return false
  return (
    /^(?:\p{Extended_Pictographic}|\p{Regional_Indicator}|[\u{1F3FB}-\u{1F3FF}\uFE0F\u200D\u20E3#*0-9])+$/u.test(v) &&
    /[\p{Extended_Pictographic}\p{Regional_Indicator}]/u.test(v)
  )
}

// Реакція-смайл каналу зберігається як «:назва»
export const emoteReaction = (name) => `:${name}`
